import { Switch } from "@/components/ui/switch";

export default function AutoGenerateBar({ on, countdown, disabled, onToggle, onCancel }) {
  return (
    <div className="flex items-center justify-between gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2" data-testid="auto-generate-bar">
      <label className="flex items-center gap-2 text-xs text-slate-700">
        <Switch checked={on} onCheckedChange={onToggle} disabled={disabled} data-testid="auto-generate-toggle" />
        <span><b>Auto-generate</b> <span className="text-slate-500">— start as soon as photos finish uploading</span></span>
      </label>
      {countdown > 0 && (
        <button type="button" onClick={onCancel} data-testid="auto-generate-cancel"
          className="shrink-0 rounded-full border border-slate-300 px-2.5 py-1 text-[11px] font-semibold text-slate-700 hover:bg-slate-50">
          Starting in {countdown}s · Cancel
        </button>
      )}
    </div>
  );
}
